var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.56 21.4454L18.9149 16.7983C22.3906 12.1535 21.4429 5.57052 16.7981 2.0948C12.1533 -1.38092 5.57034 -0.433205 2.09462 4.21157C-1.3811 8.85634 -0.43339 15.4393 4.21139 18.9151C7.94245 21.7071 13.067 21.7071 16.7981 18.9151L21.4452 23.5622C22.0292 24.1462 22.976 24.1462 23.56 23.5622C24.144 22.9782 24.144 22.0314 23.56 21.4474V21.4454ZM10.5435 18.0181C6.41542 18.0181 3.06901 14.6717 3.06901 10.5437C3.06901 6.4156 6.41542 3.06919 10.5435 3.06919C14.6715 3.06919 18.0179 6.4156 18.0179 10.5437C18.0135 14.6698 14.6697 18.0137 10.5435 18.0181Z",
    fill: "#374957"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.e6c039a7da7e66d7272c347930250820.svg";
export { ForwardRef as ReactComponent };